function getProductInfoByHandle(productHandle, cb, errorCb) {
  if (!productHandle) {
    console.log('please provide a product handle');
    return;
  }

  fetch(window.Shopify.routes.root + 'products/' + productHandle + '.js')
    .then((response) => response.json())
    .then((product) => {
      typeof cb === 'function' && cb(product);
    })
    .catch((error) => {
      typeof errorCb === 'function' && errorCb(error);
    });
}

function getAppendProductPriceDom(variantInfo) {
  if (!variantInfo) return '';

  if (variantInfo.compare_at_price > variantInfo.price) {
    return `<span class="price-old">${cart_currency_symbol.replace(
      '{{amount}}',
      (variantInfo.compare_at_price / 100).toFixed(2)
    )}</span><span class="price-last">${cart_currency_symbol.replace(
      '{{amount}}',
      (variantInfo.price / 100).toFixed(2)
    )}</span>`;
  }

  return `<span class="price-last">${cart_currency_symbol.replace(
    '{{amount}}',
    (variantInfo.price / 100).toFixed(2)
  )}</span>`;
}

function getAvailableProductVariant(product) {
  return product.variants.find((variant) => variant.available);
}

function renderProductCard(product) {
  var learnMoreButtonClass =
    'class="t4s-bl-item t4s-animation-none t4s-btn t4s-btn-custom t4s-pe-auto t4s-fnt-fm-inherit t4s-animation-none t4s-hidden-mobile-false t4s-btn-style-outline t4s-btn-effect-default"';
  var learnMoreButtonStyle =
    'style="--pri-cl: #c59852;--animation:none ;--delay-animation:0s;--button-icon-w:0px;--button-icon-w-mb:14px;--second-cl:#ffffff;--pri-cl-hover:#ffffff;--second-cl-hover:#222222;--button-fs:15px;--button-fw:500; --button-pd-lr:35px;--button-bdr:5px;--button-ls:0px;--button-mh:40px;--button-mgb:5px;--button-mgb-mb:0px;--button-fs-mb:14px;--button-mh-mb:34px;--button-pd-lr-mb:10px;--button-ls-mb:0px;"';
  var availableVariant = getAvailableProductVariant(product);
  var priceVariant = availableVariant || product.variants[0];
  var buyVariant = availableVariant || product.variants[0];

  var productDomString =
    '<div class="append-product-card__container">' +
    '<div class="product-card__image">' +
    '<img src="' +
    product.featured_image +
    '" alt="' +
    product.title +
    '">' +
    '</div>' +
    '<div class="append-product-card__info">' +
    '<div>' +
    '<div class="product-card__title">' +
    product.title +
    '</div>' +
    '<div class="product-card__price">' +
    getAppendProductPriceDom(priceVariant) +
    '</div>' +
    '<div class="product-card__description">' +
    product.description +
    '</div>' +
    '</div>' +
    '<div class="product-card__cta">' +
    '<a ' +
    learnMoreButtonClass +
    learnMoreButtonStyle +
    ' href="' +
    product.url +
    '">Learn more</a>';

  if (product.available && buyVariant) {
    var buyNowClass =
      'class="t4s-bl-item t4s-animation-none t4s-btn t4s-btn-custom t4s-pe-auto t4s-fnt-fm-inherit t4s-animation-none t4s-hidden-mobile-false t4s-btn-style-default t4s-btn-effect-default"';
    var buyNowStyle =
      'style="color: #fff;--animation:none ;--delay-animation:0s;--button-icon-w:0px;--button-icon-w-mb:14px;--pri-cl:#c59852;--second-cl:#ffffff;--pri-cl-hover:#222222;--second-cl-hover:#ffffff;--button-fs:15px;--button-fw:500; --button-pd-lr:35px;--button-bdr:5px;--button-ls:0px;--button-mh:40px;--button-mgb:0px;--button-mgb-mb:0px;--button-fs-mb:14px;--button-mh-mb:34px;--button-pd-lr-mb:10px;--button-ls-mb:0px;"';
    productDomString += '<a ' + buyNowClass + buyNowStyle + ' href="/cart/' + buyVariant.id + ':1">Buy now</a>';
  }

  productDomString += '</div></div></div>';
  return productDomString;
}

document.addEventListener('DOMContentLoaded', function() {
  var appendCardContainers = document.querySelectorAll('.append-product-card');

  if (!appendCardContainers.length) {
    console.log('No append-product-card containers found');
    return;
  }

  appendCardContainers.forEach((cardContainer) => {
    var cardType = cardContainer.getAttribute('data-card-type');
    if (cardType !== 'product-card') return;

    var productHandle = cardContainer.getAttribute('data-product-handle');
    getProductInfoByHandle(productHandle, function(product) {
      var card = $('<div class="card">' + renderProductCard(product) + '</div>');
      $(card).appendTo(cardContainer);
    });
  });
});
